import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import styles from "../styles/MobileNav.module.css";

const MobileNav = ({ brand = "MetaAI", logoSrc = "", sections = [] }) => {
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState({});
  const [subExpanded, setSubExpanded] = useState({});

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  const toggle = (i) => setExpanded((p) => ({ ...p, [i]: !p[i] }));
  const toggleSub = (key) => setSubExpanded((p) => ({ ...p, [key]: !p[key] }));

  const list = Array.isArray(sections) ? sections : [];

  return (
    <div>
      {/* 상단 바 (모바일에서 보임) */}
      <div className={styles.mobileBar}>
        <div className={styles.barInner}>
          <div className={styles.brand}>
            <Link to="/">{logoSrc ? <img src={logoSrc} alt={brand} /> : <span>{brand}</span>}</Link>
          </div>
          <button
            className={styles.hamburger}
            aria-label="메뉴 열기"
            onClick={() => setOpen(true)}
          >
            <span /><span /><span />
          </button>
        </div>
      </div>

      {/* 오버레이 */}
      <div
        className={`${styles.backdrop} ${open ? styles.show : ""}`}
        onClick={() => setOpen(false)}
      />

      {/* 오른쪽 패널 */}
      <aside className={`${styles.panel} ${open ? styles.open : ""}`} aria-hidden={!open}>
        <div className={styles.panelHead}>
          <div className={styles.brand}>
            {logoSrc ? <img src={logoSrc} alt={brand} /> : <span>{brand}</span>}
          </div>
          <button className={styles.close} aria-label="메뉴 닫기" onClick={() => setOpen(false)}>✕</button>
        </div>

        <nav className={styles.menu} role="navigation" aria-label="모바일 내비게이션">
          {list.map((sec, i) => {
            const isOpen = !!expanded[i];
            return (
              <div className={styles.section} key={sec.title}>
                <button
                  className={styles.sectionBtn}
                  aria-expanded={isOpen}
                  aria-controls={`sec-${i}`}
                  onClick={() => toggle(i)}
                >
                  <span>{sec.title}</span>
                  <svg className={`${styles.caret} ${isOpen ? styles.rot : ""}`} width="18" height="18" viewBox="0 0 24 24" aria-hidden>
                    <path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" strokeWidth="2" />
                  </svg>
                </button>

                <div id={`sec-${i}`} className={`${styles.sectionBody} ${isOpen ? styles.bodyOpen : ""}`}>
                  {sec.items?.map((it, j) => {
                    const hasChildren = Array.isArray(it.items) && it.items.length > 0;
                    if (!hasChildren) {
                      // 일반 링크
                      return (
                        <Link
                          key={it.label}
                          className={styles.link}
                          to={it.href}
                          onClick={() => setOpen(false)}
                        >
                          {it.label}
                        </Link>
                      );
                    }
                    // 하위 그룹 
                    const key = `${i}-${j}`;
                    const openSub = !!subExpanded[key];
                    return (
                      <div className={styles.subGroup} key={key}>
                        <button
                          className={styles.subGroupBtn}
                          aria-expanded={openSub}
                          aria-controls={`sub-${key}`}
                          onClick={() => toggleSub(key)}
                        >
                          <span className={styles.subTitle}>{it.title}</span>
                          <svg className={`${styles.caretSm} ${openSub ? styles.rot : ""}`} width="16" height="16" viewBox="0 0 24 24" aria-hidden>
                            <path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" strokeWidth="2" />
                          </svg>
                        </button>
                        <div id={`sub-${key}`} className={`${styles.subBody} ${openSub ? styles.subOpen : ""}`}>
                          {it.items.map((child) => (
                            <Link
                              key={child.label}
                              className={styles.subLink}
                              to={child.href}
                              onClick={() => setOpen(false)}
                            >
                              {child.label}
                            </Link>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </nav>
      </aside>
    </div>
  )
}

export default MobileNav